import './pttjpeg'

function waitForPTTJPEG(retry = 5, delay = 100) {
    return new Promise((resolve, reject) => {
        const check = () => {
            if (typeof window.pttJPEG === 'function') {
                console.log('[pttjpeg-wrapper] window.pttJPEG loaded')
                resolve(window.pttJPEG)
            } else if (retry === 0) {
                console.log(
                    '[pttjpeg-wrapper] pttJPEG not loaded after retries'
                )
                reject(new Error('pttJPEG not loaded'))
            } else {
                setTimeout(() => check(--retry), delay)
            }
        }
        check()
    })
}

export const getPTTJPEG = () => waitForPTTJPEG()
